import moment from 'moment';
import numeral from 'numeral';

type BlockFormatType = {
    size: number;
    prefix: string;
}

const applyBlocks = (blocks: BlockFormatType[], value?: string|null) => {
    if (!value) return '';

    const match = value.match(/[0-9]+/g);
    if (!match) return '';
    
    const pureValue = match.join('');

    let result = '';
    let start = 0;
    blocks.forEach(block => {
        if (block.prefix && result) result += block.prefix;
        result += block.size > 0 ? pureValue.substring(start, start+block.size) : pureValue.substring(start);
        start += block.size;
    })
    return result;
}

const phoneParts = {
  ddd: '',
  number: ''
};

const getOnlyNumbers = (value?: string) => value ? value.match(/\d+/g)?.join('') || '' : '';

const getPhoneParts = (phone?: string) => {
  if (!phone) return phoneParts;

  //tel: 01832791234    (11)  ou  1832791234    (10)
  //tel: 5501832791234  (13)  ou  551832791234  (12)
  //cel: 018997581234   (12)  ou  18997581234   (11)
  //cel: 55021999140449 (14)  ou  5521999140449 (13)

  let phoneOnlyNumbers = getOnlyNumbers(phone);
  let firstPartLength = 0;

  if (phoneOnlyNumbers.startsWith('55') && phoneOnlyNumbers.length >= 12 && phoneOnlyNumbers.length <= 14) {
    phoneOnlyNumbers = phoneOnlyNumbers.substring(2);
  }

  if (phoneOnlyNumbers.length == 10) firstPartLength = 2;
  if (phoneOnlyNumbers.length == 12) firstPartLength = 3;
  if (phoneOnlyNumbers.length == 11) {
    firstPartLength = 2;
    if (phoneOnlyNumbers[0] == '0')
      firstPartLength = 3;
  }

  if (!firstPartLength) return phoneParts;

  return {
    ddd: phoneOnlyNumbers.substring(0,firstPartLength),
    number: phoneOnlyNumbers.substring(firstPartLength)
  };
};

export const FormatHelper = {

    formatPersonalIdentificationNumber: (value?: string | null) => {
        if (!value) return '';
        
        const match = value.match(/[0-9]+/g);
        if (!match) return '';
        
        const id = match.join('');

        if (id.length >= 14) {
            const blocks = [
                { size: 2, prefix: '' },
                { size: 3, prefix: '.' },
                { size: 3, prefix: '.' },
                { size: 4, prefix: '/' },
                { size: 0, prefix: '-' },
            ];
            return applyBlocks(blocks, id);
        }

        if (id.length >= 11) {
            const blocks = [
                { size: 3, prefix: '' },
                { size: 3, prefix: '.' },
                { size: 3, prefix: '.' },
                { size: 0, prefix: '-' },
            ];
            return applyBlocks(blocks, id);
        }

        return value;
    },

    formatDate: (value: any) => value ? moment(value).format('DD/MM/yyyy') : '',

    formatDateTime: (value: any) => value ? moment(value).format('DD/MM/yyyy HH:mm:ss') : '',

    formatCurrency: (value: any) => value ? numeral(value).format('0,0.00') : '',

    formatPhone: (value: string) => {
      if (!value) return '';

      value = value.trim();
      
      if (value.startsWith('+55')) value = value.substring(3);
      
      const parts = getPhoneParts(value);

      if (parts.number.length > 4)
        return `${parts.ddd} ${parts.number.substring(0, parts.number.length-4)}-${parts.number.substring(parts.number.length-4)}`;
      
      return `${parts.ddd} ${parts.number}`;
    },

}